export interface AuditEntry {
  /** Username of the actor */
  username: string;
  /** Log type: 1=info, 2=warning, 3=error */
  ltype: 1 | 2 | 3;
  /** Category type: S=success, E=error, R=request, C=close, D=delete */
  ctype: "S" | "E" | "R" | "C" | "D";
  /** Transaction type code */
  transactionType: number;
  /** Screen / module name */
  sname: string;
  /** Human-readable result description */
  sresult: string;
  /** ISO 8601 timestamp */
  ts: string;
}

export const TX = {
  // Auth
  LOGIN: 881,
  LOGOUT: 882,

  // Billing — item operations
  BILLING_ADD_ITEM: 300,
  BILLING_REMOVE_ITEM: 301,
  BILLING_QTY_CHANGE: 302,
  BILLING_CLEAR_ALL: 303,
  BILLING_ADD_CUSTOMER: 304,
  BILLING_REMOVE_CUSTOMER: 305,
  BILLING_SELECT_LANE: 306,
  BILLING_CHECKOUT: 307,
  BILLING_PAYMENT_METHOD: 308,
  BILLING_CSV_UPLOAD: 309,

  // Billing — save & print
  BILLING_SAVE: 310,
  BILLING_SPLIT_SAVE: 311,
  BILLING_PRINT: 312,
  BILLING_REFRESH_BLOB: 313,
  BILLING_CASH_ENTRY: 314,

  // Invoices
  INVOICE_DELETE: 320,
  INVOICE_DELETE_ITEMS: 321,
  INVOICE_DELETE_REQUEST: 322,
  INVOICE_REPRINT: 323,

  // Support
  SUPPORT_SEND: 400,
  SUPPORT_BOT_CMD: 401,
  SUPPORT_TICKET_RAISE: 402,
  SUPPORT_TICKET_CLOSE: 403,

  // Tickets
  TICKET_RAISE: 500,
  TICKET_APPROVE: 501,
  TICKET_REJECT: 502,

  // Store Onboarding
  STORE_CREATE: 600,

  // Masters
  SUPPLIER_SAVE: 700,
  DISTRIBUTOR_SAVE: 710,
  DISTRIBUTOR_UPDATE: 711,
  DISTRIBUTOR_DELETE: 712,

  // User Management
  USER_CREATE: 720,
  USER_UPDATE: 721,
  USER_CHANGE_PASSWORD: 722,
  USER_DEACTIVATE: 723,
  USER_REACTIVATE: 724,

  // Shop Management
  SHOP_CREATE: 730,
  SHOP_UPDATE_LOGO: 731,

  // Scheme Master
  SCHEME_SAVE: 740,

  // WOB Master
  WOB_SAVE: 750,
  LANE_ADD: 751,
  LANE_DELETE: 752,
  LANE_SET_DEFAULT: 753,
  SEQUENCE_UPDATE: 754,
  PAYMENT_DEFAULT: 755,
  KOT_UPDATE: 756,
  TRACKER_TOGGLE: 757,
  DUPLEX_TOGGLE: 758,

  // Table Order Config
  TABLE_CONFIG_SAVE: 760,
  TABLE_PRINTER_SAVE: 761,
  TABLE_PASSWORD_UPDATE: 762,

  // Table Order Operations
  TO_ADD_ITEM: 830,
  TO_QTY_CHANGE: 831,
  TO_DELETE_ITEM: 832,
  TO_ADD_BILL: 833,
  TO_DELETE_BILL: 834,
  TO_MOVE_BILL: 835,
  TO_CUSTOMER_SET: 836,
  TO_CUSTOMER_CLEAR: 837,
  TO_WAITER_CHANGE: 838,
  TO_NC_TOGGLE: 839,
  TO_DISCOUNT_CHANGE: 840,
  TO_KOT_PRINT: 841,
  TO_PRINT_BILL: 842,
  TO_CHECKOUT: 843,
  TO_OPEN_POUR: 844,
  TO_TABLE_REFRESH: 845,
  TO_POUR_SIZE: 846,
  TO_REFRESH_BLOB: 847,

  // Masters
  CATEGORY_CREATE: 770,
  SUBCATEGORY_CREATE: 771,
  BRAND_CREATE: 772,
  BRAND_ITEM_ADD: 773,
  MATERIAL_CREATE: 774,
  MARL_EDIT: 775,
  POPQTY_UPDATE: 776,
  HSN_CREATE: 777,
  KSBCL_MAP: 778,
  CSV_PRICE_IMPORT: 779,
  CSV_OFFERS_IMPORT: 780,
  CSV_NALC_IMPORT: 781,
  MASTER_SYNC: 782,
  PKTYPE_CREATE: 783,
  PKSIZE_CREATE: 784,

  // Inventory (Material Movement)
  INVENTORY_SAVE: 790,
  INVENTORY_CSV_UPLOAD: 791,

  // Administration
  ADMIN_VERIFY_STORE: 800,
  ADMIN_INVOICE_DATE_CHANGE: 801,
  ADMIN_GRN_DATE_CHANGE: 802,
  ADMIN_REDUCE_INV_QTY: 803,
  ADMIN_DELETE_INV_ITEM: 804,
  ADMIN_GO_LIVE: 805,
  ADMIN_KSBCL_PURI_MAP: 806,
  ADMIN_DELETE_TRANSFER: 807,

  // Control Management
  CM_PROFILE_ADD: 800,
  CM_PROFILE_UPDATE: 801,
  CM_ACCESS_SAVE: 802,
  CM_PROFILE_EXPORT: 803,
  CM_FIELD_ADD: 804,
  CM_FIELD_DELETE: 805,
  CM_MASTER_UPDATE: 806,
  CM_SHORTCUT_ADD: 807,
  CM_SHORTCUT_DELETE: 808,
  CM_EXPENSE_ADD: 809,
  CM_REPORT_CONFIG: 810,
  CM_THERMAL_CONFIG: 811,

  // Utilities
  UTIL_LOG_CLEANUP: 810,
  UTIL_BACKUP_DOWNLOAD: 811,

  // Transactions
  TX_VALIDATE: 820,
  TX_APPROVAL_REQUEST: 821,

  // GRN Alcohol
  GRN_ALC_SAVE: 200,
  GRN_ALC_CANCEL: 201,
  GRN_ALC_PRICE_UPDATE: 202,
  GRN_ALC_MAPPING_REQUEST: 203,

  // GRN Non-Alcohol
  GRN_NALC_SAVE: 210,
  GRN_NALC_CANCEL: 211,

  // GRN Return (Alcohol)
  GRN_RETURN_SAVE: 250,

  // GRN Return (Non-Alcohol)
  GRN_NALC_RETURN_SAVE: 255,

  // Mass Invoice
  MASS_INVOICE_SAVE: 311,
  MASS_INVOICE_SPLIT_SAVE: 312,

  // Mass Invoice Sales
  MASS_INVOICE_SALES_SAVE: 315,
  MASS_INVOICE_SALES_SPLIT_SAVE: 316,

  // Store Expenses
  EXPENSE_SAVE: 850,
  EXPENSE_DELETE: 851,
  EXPENSE_CORRECTION_SAVE: 852,

  // Supplier Bill Pay
  SUPPLIER_BILLPAY_SAVE: 860,
  SUPPLIER_BILLPAY_REQ_SAVE: 861,

  // Upload Indent
  INDENT_UPLOAD: 870,
  INDENT_DELETE: 871,

  // Mass Price Update
  MASS_PRICE_PUBLISH: 880,
  MDM_PRICE_PUBLISH: 881,

  // Mass Stock Transfer
  STOCK_TRANSFER_PRICE_RECORD: 885,
  STOCK_TRANSFER_SAVE: 886,
  STOCK_TRANSFER_DELETE: 887,

  // Cash Entry
  CASH_ENTRY_ADD: 890,
  CASH_ENTRY_DELETE: 891,
  CASH_ENTRY_GET_SALES: 892,
  CASH_ENTRY_DAY_CLOSE: 893,
  CASH_ENTRY_ADD_LEDGER: 894,

  // Stock Transfer (Single)
  STOCK_TRANSFER_SINGLE_SAVE: 895,

  // Selling Price Master
  SELLING_PRICE_SAVE: 896,

  // Cron Jobs
  CRON_JOB_RUN: 897,
} as const;
